<template>
  <v-container class="users-list">
    <v-card>
    <v-card-title>
      <h3>Add User</h3>
    </v-card-title>
    <v-container>
      <v-card-media>
        <v-flex class="row">
          <v-flex xs8 m8>
            <v-text-field label="User Name" v-model="user.username" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-text-field label="Full Name" v-model="user.name" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-text-field label="Email" v-model="user.email" type="email" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-text-field label="Password" v-model="user.password" type="password" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-text-field label="New Password" v-model="user.c_password" type="password" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-text-field label="Customer ID" v-model="user.cid" type="number" default-value="0" required="required"></v-text-field>
          </v-flex>
          <v-flex xs8 m8>
            <v-btn @click="addUser()" class="font-weight-light" color="success" :disabled="loading || user.username === '' || user.name === '' || user.email === '' || user.password === '' || user.c_password === ''">
              <span v-text="loading?'Adding User...':'Add User'"></span>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-card-media>
    </v-container>
    </v-card>
  </v-container>
</template>
<script>
import axios from './../api/index'
  export default {
    name: "AddUser",
    data: () => ({
      loading: false,
      user: {
        username: '',
        name: '',
        email: '',
        password: '',
        c_password: '',
        cid: ''
      },
    }),
    methods:{
      addUser: function (){
        let self = this
        self.loading = true
        axios.post('/auth/signup', self.user).then(response => {
          self.$toasted.show('User added successfully')
          self.reset();
          self.$router.push('/users');
          self.loading = false
        }).catch(function (catchError){
          let response = {...catchError.response.data}
          let all_errors = response.errors || response.error
          if(all_errors && Object.keys(all_errors).length > 0){
            for (const property in all_errors) {
              self.$toasted.show(`${all_errors[property]}`)
            }
          }else
            self.$toasted.show('Error in adding user')
          self.loading = false
        })
      },
      reset(){
        this.user = {
          username: '',
          name: '',
          email: '',
          password: '',
          c_password: '',
          cid: ''
        }
      }
    },
    mounted() {
      
    }
  }
</script>
<style>
.users-list .v-label.v-label--is-disabled.theme--light {
  /*left: 15px !important;*/
}
.users-list .row{
  margin-right: 0;
  margin-left: 0;
}
</style>